import Widgets from 'flarum/extensions/afrux-forum-widgets-core/common/extend/Widgets';

import BirthdayUsersWidget from './components/BirthdayUsersWidget';

export default function (app) {
  let widgets = new Widgets();
  widgets.add({
      key: 'birthdayUsersWidget',
      component: BirthdayUsersWidget,
      isDisabled: () => {
        const showWidget = app.forum.attribute('datlechin-birthdays.showWidget');
        if (!showWidget) return false;

        const loadWithInitialResponse = app.forum.attribute('afrux-forum-widgets-core.preferDataWithInitialLoad');

        return (!loadWithInitialResponse && (!app.forum.attribute('canSearchUsers')))
          || (loadWithInitialResponse && !app.forum.onlineUsers().length);
      },
      isUnique: true,
      placement: 'end',
      position: 1,
    })
    .extend(app, 'datlechin-birthdays');
}
